<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card id="customerListcard" :loading="loading">
          <h2 v-if="!!!userList">Keine Benutzer gefunden</h2>
          <v-data-table
            :headers="headers"
            :items="userList"
            :search="search"
            :itemsPerPage="-1"
            multi-sort
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Benutzer suchen"
                class="pa-4"
                :outlined="true"
                :filled="true"
                :clearable="true"
                background-color="#e8eff7"
              ></v-text-field>
            </template>

            <template slot="item.active" slot-scope="{ item }">
              <v-chip small :color="item.active ? 'success' : 'error'">{{
                item.active ? "Aktiv" : "Inaktiv"
              }}</v-chip>
            </template>

            <template slot="item.activated" slot-scope="{ item }">
              <v-switch
                v-model="item.activation.activated"
                @click="updateUserActivation(item)"
                color="green"
              />
            </template>

            <template slot="item.role" slot-scope="{ item }">
              <v-icon
                v-if="item.role === 'superuser' || item.role === 'manager'"
                color="orange"
                >mdi-account-tie</v-icon
              >
              {{ userRole(item) }}
            </template>

            <template slot="item.customerId" slot-scope="{ item }">
              {{ getCustomerName(item.customerId) }}
            </template>

            <template slot="item.actions" slot-scope="{ item }">
              <v-icon
                v-show="!item.activation.activated"
                small
                class="mr-2"
                @click="askSendActivation(item)"
                >mdi-account-reactivate</v-icon
              >
              <v-icon small class="mr-2" @click="createIdCard(item)"
                >mdi-printer</v-icon
              >
              <v-icon small class="mr-2" @click="editItem(item)"
                >mdi-pencil</v-icon
              >

              <v-icon
                v-if="!isLoggedInUser(item)"
                small
                class="mr-2"
                @click="askDelete(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dlgDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Benutzer löschen?</v-card-title>
        <v-card-text>
          Soll der Benutzer
          <strong>{{ deleteCustomerName }}</strong> wirklich gelöscht werden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" outlined text @click="dlgDelete = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="red darken-1" @click="deleteCustomer">
            <v-icon>mdi-delete</v-icon>Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dlgSendActivation" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Aktivierungslink senden?</v-card-title>
        <v-card-text>
          Möchten Sie den Aktivierungslink für den Benutzer
          <strong>{{ sendActivationCustomerName }}</strong> wirklich erneut
          senden?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            outlined
            text
            @click="dlgSendActivation = false"
            >Abbrechen</v-btn
          >
          <v-btn dark color="secondary" @click="resendActivation">
            <v-icon>mdi-account-reactivate</v-icon>Senden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService";
import moment from "moment";
import FileSaver from "file-saver";
//import pdf from "vue-pdf";
export default {
  name: "UserList",

  data: () => ({
    loading: false,
    search: "",
    dlgDelete: false,
    deleteItem: false,
    deleteCustomerName: "",
    sendActivationCustomerName: "",
    dlgSendActivation: false,
    activationItem: null,

    headers: [
      { text: "Status", value: "active", width: "100px" },
      { text: "Aktiviert", value: "activated", width: "100px" },
      { text: "Rolle", value: "role", width: "150px" },
      { text: "Email", value: "email", width: "150px" },
      { text: "Kunde", value: "customerId" },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "110px",
        align: "right",
      },
    ],
  }),
  methods: {
    createIdCard(item) {
      //this.$refs.UserList.createIdCards();
      this.$store.commit("SET_APP_LOADING", true);
      UserService.createIdCard(item._id)
        .then((response) => {
          let filename = "idcards_" + moment().format("YYYY-MM-DD") + ".pdf";
          const bytes = new Uint8Array(response.data);

          FileSaver.saveAs(
            new Blob([bytes], {
              type: "application/pdf;",
            }),
            filename
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.commit("SET_APP_LOADING", false);
        });
    },

    async updateUserActivation(item) {
      try {
        let userResponse = await UserService.fetch(item._id);
        let user = userResponse.data.data;

        console.log(user);
        if (user.activation.activated) {
          user.activation.activated = false;
        } else {
          user.activation.activated = true;
        }

        await UserService.saveUser({ id: user._id, data: user });
        this.$notify({
          group: "dataline",
          type: "success",
          title: "Benutzer gespeichert",
          text: "Benutzer erfolgreich gespeichert",
        });

        item.activation.activated = user.activation.activated;
      } catch (error) {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Fehler",
          text: error.message,
        });
      }
    },
    isLoggedInUser(item) {
      const user = this.$store.getters["user/getUser"];
      if (user._id === item._id) {
        return true;
      }
      return false;
    },
    userRole(item) {
      if (item.role == "superuser") return "Superuser";
      else if (item.role == "manager") return "System Admin";
      else if (item.role == "customer-admin") return "Kunden Admin";
      else if (item.role == "customer") return "Kunden Benutzer";
      else return item.role;
    },
    askDelete(item) {
      this.deleteCustomerName = item.firstname + " " + item.lastname;
      this.dlgDelete = true;
      this.deleteItem = item;
    },
    askSendActivation(item) {
      this.sendActivationCustomerName = item.firstname + " " + item.lastname;
      this.dlgSendActivation = true;
      this.activationItem = item;
    },
    editItem(item) {
      this.$router.push({ name: "user-edit", params: { id: item._id } });
    },
    getCustomerName(customerId) {
      if (customerId == "system") {
        return customerId;
      }

      const customer = this.$store.getters["customer/getCustomerList"].find(
        (item) => item._id === customerId
      );
      if (!customer) {
        return "Unknown Customer";
      }

      return (
        customer.name +
        " / " +
        customer.adresse +
        ", " +
        customer.plz +
        " " +
        customer.ort
      );
    },
    resendActivation() {
      UserService.resendActivation(this.activationItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Email versendet",
            text:
              "Aktivierungslink an Benutzer " +
              this.activationItem.email +
              " wurde gesendet",
          });
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Senden fehlgeschlagen",
            text: "Das Aktivierungsmail konnte nicht versendet werden",
          });
        });
      this.dlgSendActivation = false;
    },
    deleteCustomer() {
      this.dlgDelete = false;
      this.$store
        .dispatch("user/deleteUser", this.deleteItem._id)
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "info",
            title: "Benutzer gelöscht",
            text: "Benutzer " + this.deleteItem.name + " wurde gelöscht",
          });
          this.deleteCustomerName = "";
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Löschen fehlgeschlagen",
            text:
              "Benutzer " +
              this.deleteItem.name +
              " konnte nicht gelöscht werden.",
          });
        });
    },
  },

  computed: {
    userList() {
      return this.$store.getters["user/getUserList"];
    },

    idCardList: {
      get() {
        return this.$store.getters["user/getIdCardList"];
      },
      set(data) {
        this.$store.commit("user/SET_IDCARD_LIST", data);
      },
    },
  },

  created() {
    this.loading = true;
    this.$store
      .dispatch("customer/fetchCustomerList")
      .then(() => {
        return this.$store.dispatch("user/fetchUserList");
      })
      .then(() => {})
      .catch((error) => {
        if (error.response.status != 401) {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
#Customerlistcard {
  margin: 20px;
}
</style>
